export const FIREBASE_MAIN_COLLECTION = "ai-art";

export const FIREBASE_USERS_COLLECTION = "users";

export const FIREABSE_SAVED_POSTS_COLLECTION = "saved-posts";

export const FIREBASE_ACTIVITY_COLLECTION = "activity";

export const FIREBASE_COMMENTS_COLLECTION = "comments";

export const FIREBASE_POSTS_COLLECTION = "posts";

// export const HF_MODEL = "Lykon/art-diffusion-xl-0.9";
// export const HF_MODEL = "CompVis/stable-diffusion-v1-4";
// export const HF_MODEL = "stabilityai/stable-diffusion-3.5-large";
export const HF_MODEL = "stabilityai/stable-diffusion-xl-base-1.0";



export const ICONS = {
  save: "/bookmark.png",
  unsave: "/save-instagram (1).png",
  liked: "/heart (4).png",
  unliked: "/heart (3).png",
};

export const SLIDES = ["/cover.png", "/2.png", "/Untitled design (16).png"];

export const SLIDES_INTERVALS = [3000, 9000, 9000];

export const IMAGES = [
  "/imagine-grid/0.webp",
  "/imagine-grid/1.jpg",
  "/imagine-grid/2.webp",
  "/imagine-grid/3.jpg",
  "/imagine-grid/4.jpg",
  "/imagine-grid/5.png",
  "/imagine-grid/6.png",
  "/imagine-grid/7.webp",
  "/imagine-grid/8.jpg",
];
